if (!customElements.get('cart-drawer-info-slider')) {
  class CartDrawerInfoSlider extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', (e) => {
          this.init();
        });
      }
      this.init();


    }

    init() {

      var swiperArea = document.querySelector('.cart-drawer__swiper');

      const slideCount = swiperArea ? swiperArea.querySelectorAll('.swiper-slide').length : 0;
      this.slider = new Swiper(swiperArea, {
        direction: 'vertical',
        slidesPerView: 1,
        loop: slideCount > 1,
        allowTouchMove: false,
        autoplay: {
          delay: 5000,
        }
      });
    }
  }

  customElements.define('cart-drawer-info-slider', CartDrawerInfoSlider);
}
